import React from "react";
import { HeartIcon } from "../ui";
import hero1 from "../../assets/images/hero_1.jpg";
import hero2 from "../../assets/images/hero_2.jpg";
import hero3 from "../../assets/images/hero_3.jpg";
import hero4 from "../../assets/images/hero_4.jpg";
import hero5 from "../../assets/images/hero_5.jpg";
import hero6 from "../../assets/images/hero_6.jpg";
import hero7 from "../../assets/images/hero_7.jpg";

const floatingPhotos = [
  {
    src: hero1,
    cls: "w-[70px] h-[88px] sm:w-[120px] sm:h-[150px] top-[8%] left-[3%] animate-floatA",
  },
  {
    src: hero2,
    cls: "w-[48px] h-[60px] sm:w-[80px] sm:h-[100px] top-[14%] left-[30%] animate-floatB",
  },
  {
    src: hero3,
    cls: "w-[64px] h-[80px] sm:w-[110px] sm:h-[140px] top-[5%] right-[6%] animate-floatC",
  },
  {
    src: hero4,
    cls: "w-[52px] h-[66px] sm:w-[90px] sm:h-[115px] top-[44%] left-[2%] animate-floatD",
  },
  {
    src: hero5,
    cls: "w-[64px] h-[82px] sm:w-[115px] sm:h-[145px] top-[42%] right-[4%] animate-floatE",
  },
  {
    src: hero6,
    cls: "hidden sm:block w-[100px] h-[125px] bottom-[8%] left-[20%] animate-floatF",
  },
  {
    src: hero7,
    cls: "hidden sm:block w-[105px] h-[130px] bottom-[6%] right-[20%] animate-floatG",
  },
];

export default function Hero() {
  return (
    <section className="min-h-screen bg-blush flex flex-col items-center justify-center px-[5%] pt-[120px] pb-20 relative overflow-hidden text-center">
      {/* Floating photos */}
      <div
        className="absolute inset-0 pointer-events-none overflow-hidden"
        aria-hidden="true"
      >
        {floatingPhotos.map((p, i) => (
          <div
            key={i}
            className={`absolute rounded-[20px] overflow-hidden ${p.cls}`}
          >
            <img
              src={p.src}
              alt=""
              className="w-full h-full object-cover block"
            />
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 animate-fadeUp">
        <div className="inline-flex items-center gap-1.5 bg-white rounded-full px-4 py-1.5 text-[13px] font-medium text-rose-dark mb-7 border border-blush-mid animate-fadeIn">
          <span>★</span> Real Connections · Malawi
        </div>

        <div className="w-[72px] h-[72px] rounded-[20px] bg-black flex items-center justify-center mx-auto mb-6 animate-heartbeat">
          <HeartIcon className="w-9 h-9 text-white" />
        </div>

        <h1 className="text-[clamp(38px,6vw,68px)] font-bold tracking-[-2px] leading-[1.05] mb-2.5">
          Max &amp; Sherry
          <br />
          ConnectPlus
        </h1>
        <p className="text-[15px] font-normal tracking-[2px] text-muted uppercase mb-6">
          Connecting People
        </p>
        <p className="text-[17px] text-muted font-light max-w-[480px] leading-relaxed mx-auto mb-10">
          Connect with people who share your interests, values, and vibe. Real
          connections, built on what matters to you.
        </p>

        <div className="flex flex-col sm:flex-row gap-3.5 flex-wrap justify-center">
          {/* Primary action: Scroll to Pricing */}
          <a
            href="#pricing"
            className="bg-black text-white px-9 py-4 rounded-full text-base font-medium no-underline inline-flex items-center justify-center gap-2 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.2)] transition-all duration-200 w-full sm:w-auto"
          >
            <HeartIcon className="w-[18px] h-[18px]" />
            View Plans & Subscribe
          </a>
          <a
            href="#how-it-works"
            className="bg-transparent text-black px-9 py-4 rounded-full text-base font-medium no-underline border border-black/20 hover:border-black/50 hover:-translate-y-0.5 transition-all duration-200 w-full sm:w-auto"
          >
            See how it works
          </a>
        </div>

        {/* Mobile-only quick hint */}
        <p className="mt-8 text-[13px] text-muted sm:hidden">
          Already have an account?{" "}
          <a href="/pay" className="text-rose-dark font-semibold underline">
            Log in to pay
          </a>
        </p>
      </div>
    </section>
  );
}
